/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompassCurrentSensorSettings
 */
export interface CompassCurrentSensorSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CompassCurrentSensorSettings
     */
    sensitivity_smart_adaptive_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompassCurrentSensorSettings
     */
    sensitivity_disabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompassCurrentSensorSettings
     */
    sensitivity: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompassCurrentSensorSettings
     */
    sensitivity_locked: boolean;
}

/**
 * Check if a given object implements the CompassCurrentSensorSettings interface.
 */
export function instanceOfCompassCurrentSensorSettings(value: object): value is CompassCurrentSensorSettings {
    if (!('sensitivity_smart_adaptive_on' in value) || value['sensitivity_smart_adaptive_on'] === undefined) return false;
    if (!('sensitivity_disabled' in value) || value['sensitivity_disabled'] === undefined) return false;
    if (!('sensitivity' in value) || value['sensitivity'] === undefined) return false;
    if (!('sensitivity_locked' in value) || value['sensitivity_locked'] === undefined) return false;
    return true;
}

export function CompassCurrentSensorSettingsFromJSON(json: any): CompassCurrentSensorSettings {
    return CompassCurrentSensorSettingsFromJSONTyped(json, false);
}

export function CompassCurrentSensorSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompassCurrentSensorSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'sensitivity_smart_adaptive_on': json['sensitivity_smart_adaptive_on'],
        'sensitivity_disabled': json['sensitivity_disabled'],
        'sensitivity': json['sensitivity'],
        'sensitivity_locked': json['sensitivity_locked'],
    };
}

export function CompassCurrentSensorSettingsToJSON(json: any): CompassCurrentSensorSettings {
    return CompassCurrentSensorSettingsToJSONTyped(json, false);
}

export function CompassCurrentSensorSettingsToJSONTyped(value?: CompassCurrentSensorSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sensitivity_smart_adaptive_on': value['sensitivity_smart_adaptive_on'],
        'sensitivity_disabled': value['sensitivity_disabled'],
        'sensitivity': value['sensitivity'],
        'sensitivity_locked': value['sensitivity_locked'],
    };
}

